import createDataContext from "./createDataContext";
import { storage, firestore } from "../api/firebase";
import { auth, admin } from "../api/firebase";


const specialCharRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|<>/?]+/;

const itemsReducer = (state, action) => {
  switch (action.type) {
    case "set_error":
      return {...state, error: action.payload};
    case "set_folders":
      return {...state, folders: action.payload};
    case "set_items":
      return {...state, items: action.payload};  
    default:
      return state;
  }
};

/* 
 * Función asíncrona para la creación de un producto.
 * Parámetros: nombre del producto, precio (puntos), descripción
 *  del producto, folder (categoría) y la imagen del producto.
 * 
 * Esta función realiza llamadas a servicios como Firestore y FireStorage
 * para la creación de productos en la base de datos y la carga de imágenes
 * al sistema.
 * 
 * Retorna: Verdadero o Falso según el éxito en la creación del producto.
 */
const createItem = (dispatch) => async({name, unitPrice, description,folder, file})=>{
  let error = "";
  let trimmedDesc = description.trim();
  // Validación de la información en los productos.
  if (!name || name.length < 3 || name.length > 40) {
    error += "El nombre debe tener entre 3 y 40 caracteres.\n";
  }
  if(specialCharRegex.test(name)){
    error += "El nombre no puede contener caracteres especiales.\n";
  }
  if(specialCharRegex.test(description)){
    error += "La descripción no puede contener caracteres especiales.\n";
  }
  if (!unitPrice || unitPrice <= 0 || unitPrice > 9999999) {
    error += "Los puntos deben de ser mayores a cero y menores a 9,999,999.\n";
  }
  if(unitPrice%1 !== 0){
    error += "Los puntos deben ser unidades enteras.\n";
  }
  if(!description || trimmedDesc.length < 3 || description.length > 80){
    error += "La descripción debe tener entre 3 y 80 caracteres.\n";
  }
  if (!folder || folder.length === 0) {
    error += "El folder no existe.\n";
  }
  if (!file) {
    error += "Debes de subir una imagen.\n";
  }else { 
    if(!file.type.includes("image")){
      error += "El archivo no es una imagen.\n";
    }
    if (file.size > 200000) {
      error += "El tamaño de la imagen debe ser meno a los 200KB.\n";
    }
  }
  if (error.length > 0) {
    // Actualizar el estado "error" a los errores identificados previamente.
    await dispatch({type:"set_error", payload:error});
    return false;
  }
  else{
    try {
      // Carga de imágenes a FireStorage
      const itemImagesRef = storage.ref().child(`itemImages/${new Date().getTime()+"_"+file.name}`);
      const response = await itemImagesRef.put(file);
      const url = await response.ref.getDownloadURL();
       
      // Inserción en Firestore (Base de datos)
      const res = await firestore.collection("items").add({
        name,
        unitPrice,
        description,
        folder,
        url: url.toString(),
        visible: true
      });

      // Creación de log para auditorías
      // Código de acción: ADD
      createLog(res.id, "ADD");

    } catch (err) {
      // Actualización de estados.
      dispatch({type:"set_error", payload:err});
    }
    // Actualización de estados, elimina el mensaje de error.
    await dispatch({type:"set_error", payload:""});
    return true;
  }
  
}

/* 
 * Función asíncrona para la actualización de un producto.
 * @ param
 * Parámetros: nombre del producto, precio (puntos), descripción
 *  del producto, folder (categoría) y la imagen del producto.
 * 
 * Esta función realiza llamadas a servicios como Firestore y FireStorage
 * para la actualización de productos en la base de datos y la carga de imágenes
 * al sistema.
 * 
 * Retorna: Verdadero o Falso según el éxito en la creación del producto.
 */
const updateItem = (dispatch) => async({id, name, unitPrice, folder, description, file, editedFile}) =>{
  let error = ""
  let trimmedDesc = description.trim();
  //Validación de la información.
  if (!name || name.length < 3 || name.length > 40) {
    error += "El nombre debe tener entre 3 y 40 caracteres.\n";
  }
  if(specialCharRegex.test(name)){
    error += "El nombre no puede contener caracteres especiales.\n";
  }
  if(specialCharRegex.test(description)){
    error += "La descripción no puede contener caracteres especiales.\n";
  }
  if (!unitPrice || unitPrice <= 0 || unitPrice > 9999999) {
    error += "Los puntos deben de ser mayores a cero y menores a 9,999,999.\n";
  }
  if(unitPrice%1 !== 0){
    error += "Los puntos deben ser unidades enteras.\n";
  }
  if(!description || trimmedDesc.length < 3 || description.length > 80){
    error += "La descripción debe tener entre 3 y 80 caracteres.\n";
  }
  if (!folder || folder.length === 0) {
    error += "El folder no existe.\n";
  }
  // Verificar si el archivo fue modificado.
  if (editedFile) {
    if (!file) {
      error += "Debes de proporcionar una imagen.\n"
    }else { 
      // Validaciones para la imagen.
      if(!file.type.includes("image")){
        error += "El archivo no es una imagen.\n"
      }
      if (file.size > 200000) {
        error += "El tamaño de la imagen debe ser menor a los 200KB\n"
      }
    }
  }
  if (error.length > 0) {
    await dispatch({type:"set_error", payload:error});
    return false;
  }
  else{
    try {
      if (editedFile) {
        const itemImagesRef = storage.ref().child(`itemImages/${new Date().getTime()+"_"+file.name}`);
        const response = await itemImagesRef.put(file);
        const url = await response.ref.getDownloadURL();
        firestore.collection("items").doc(id).update({
          name,
          unitPrice,
          folder,
          description,
          url: url.toString(),
        });
        createLog(id, "UPDATE");
      }else{
        firestore.collection("items").doc(id).update({
          name,
          unitPrice,
          folder,
          description
        });
        createLog(id, "UPDATE");
      }
    } catch (err) {
      dispatch({type:"set_error", payload:err.message});
      return false;
    }
    await dispatch({type:"set_error", payload:""});
    return true;
  }
 
}

const createFolder = ()=> (name) =>{
  if(name && name.trim().length > 3){
    firestore.collection("folders").doc(name).set({visible: true})
  }
}


const deleteItem = ()=> (id) =>{
  firestore.collection("items").doc(id).update({visible: false})
  createLog(id, "DELETE");
}

/**
 * Esta función tiene como propósito actualizar el precio de
 * un producto.
 * @param {id: Id del producto en firestore, n: Nuevo valor}
 * @returns {success: boolean, message: string}
 */
const updatePrice = ()=> (id, n) =>{
  try{
    if(isNaN(n)){
      throw new Error("Los puntos deben de tener un valor numérico");
    }
    else {
      if (n%1 !== 0){
        throw new Error("Los puntos deben ser números enteros.");
      }
      if(n <= 0){
        throw new Error("Los puntos a asignar deben ser mayores a cero.");
      }
      if(n > 9999999 ){
        throw new Error("Los puntos a asignar deben ser menores a 9,999,999");
      }
    }
    firestore.collection("items").doc(id).update({unitPrice: n});
    createLog(id, "UPDATE");
    return {success: true, message:"Puntos actualizados exitosamente."};
  }catch(error){
    return {success: false, message: error.message};
  }
}

const setFolders = (dispatch) =>(folders) =>{
  dispatch({type:"set_folders", payload: folders})
}
const setItems = (dispatch) =>(items) =>{
  dispatch({type:"set_items", payload: items})
}

const clearError = (dispatch) =>() =>{
  dispatch({type:"set_error", payload: ""})
}

const createLog = (id, code)=>{
  let currentUser = auth.currentUser;
  if (currentUser) {
    firestore.collection("logs").doc().set({
      date: admin.firestore.Timestamp.fromDate(new Date()),
      user: currentUser.uid,
      code,
      id
    })
  }
}


export const { Provider, Context } = createDataContext(
  itemsReducer,
  {setFolders, setItems, createItem, clearError, deleteItem, updatePrice, updateItem, createFolder},
  {error: "", items:[], folders:[]}
);